import styled, { css } from 'styled-components';
import { BREAKPOINTS } from '../../../../../../constants/layout.mjs';
import { theme } from '../../../../../../constants/theme.mjs';
import '../../../../../Container/index.mjs';
import { WrapPadding } from '../../../../../Container/Container.styles.mjs';
import '../../../../../StyleableSvgImage/index.mjs';
import { withCssTransition } from '../../../DropdownMenu/DropdownMenu.styles.mjs';
import { Container as Container$1 } from '../../../../../Container/Container.mjs';
import { StyleableSvgImage } from '../../../../../StyleableSvgImage/StyleableSvgImage.mjs';
"use strict";
const MICROSITE_MENU_Z_INDEX = theme.zIndex.header - 1;
const HEADER_NAVIGATION_MICROSITE_MENU_HEIGHT = 130;
const TRANSITION_DURATION_MS = 250;
const Wrap = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: ${MICROSITE_MENU_Z_INDEX};
`;
const MenuWrap = styled.nav`
  background: ${({
  motif
}) => theme.colors.menu.base[motif]};
  display: flex;
  height: 0;
  opacity: 0;
  filter: drop-shadow(0 12px 48px rgb(33 35 39 / 0.12))
    drop-shadow(0 0 1px rgb(33 35 39 / 0.08));
  position: absolute;
  width: 100%;
  ${withCssTransition(["height", "opacity"])};

  ${({
  $slideInView,
  $height
}) => $slideInView && css`
      padding-top: 48px;
      height: ${$height}px;
      opacity: 1;
    `}
`;
const MenuInnerWrap = styled.div`
  display: flex;
  justify-content: center;
  opacity: 0;
  overflow: hidden;
  width: 100%;

  ${({
  $shouldShow
}) => $shouldShow && css`
      opacity: 1;
      padding: 8px 16px 16px;
    `}
`;
const Container = styled(Container$1)`
  margin: 0;
  padding: 0;
  max-width: 1200px;

  ${WrapPadding} {
    flex-direction: row;
    align-items: flex-start;

    @media ${BREAKPOINTS.SMALL_MOBILE_AND_DOWN} {
      flex-direction: column;
      align-items: stretch;
    }
  }
`;
const SubNavItemsWrapper = styled.div`
  gap: 16px;
  display: flex;
  justify-content: center;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    gap: 8px;

    ${({
  $isDenseGrid
}) => $isDenseGrid && css`
        gap: 4px;
      `}
  }
`;
const SubNavItem = styled.button`
  align-items: center;
  animation: fade-in-quick 0.5s linear;
  display: flex;
  position: relative;
  background: transparent;
  outline: none;
  border: none;
  flex-direction: column;
  flex: 1 1 0px;
  max-width: ${({
  $maxWidth
}) => `${$maxWidth}px`};
  padding: 8px 8px 16px;
  border-radius: 6px;
  transition: all 0.15s linear;
  cursor: pointer;

  &:hover {
    box-shadow:
      0 0 1px 0 rgb(33 35 39 / 0.08),
      0 4px 16px 2px rgb(33 35 39 / 0.08);
  }

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    padding: 6px 6px 16px;
  }

  ${({
  $isActive
}) => $isActive && css`
      background: #eeeff1;
    `}

  @keyframes fade-in-quick {
    0% {
      opacity: 0;
    }

    15% {
      opacity: 0.25;
    }

    70% {
      opacity: 1;
    }

    100% {
      opacity: 1;
    }
  }
`;
const SvgImage = styled(StyleableSvgImage)`
  color: #808893;
  transition: color 0.2s ease-in-out;
`;
const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;
const StyledImg = styled.img`
  object-fit: contain;
  height: 80px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    height: 64px;
  }
`;
const Title = styled.h3`
  align-items: center;
  color: #212327;
  display: flex;
  font-size: 16px;
  font-weight: 700;
  justify-content: center;
  margin-bottom: 0;
  margin-top: 8px;
  text-align: center;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    font-size: 14px;
  }
`;
const Description = styled.p`
  color: #50565e;
  font-size: 12px;
  height: 100%;
  line-height: 14px;
  margin-bottom: 0;
  margin-top: 4px;
  text-align: center;
  text-wrap: pretty;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    font-size: 11px;
  }
`;
const CompareExploreAnchor = styled.a`
  background: transparent;
  border: none;
  color: #006fff;
  cursor: pointer;
  font-size: 12px;
  line-height: 14px;
  margin-top: 8px;
  min-height: 14px;
  outline: none;
  z-index: 1;
`;
const Badge = styled.span`
  align-items: center;
  border-radius: 3px;

  border: 1px solid ${theme.colors.primaryBlue};
  color: ${theme.colors.primaryBlue};
  display: flex;
  font-size: 9px;
  font-style: normal;
  height: 16px;
  justify-content: center;
  line-height: 16px;
  letter-spacing: -0.018px;
  margin-top: 8px;
  padding: 2px 3px;
  width: fit-content;
`;
export { Badge, CompareExploreAnchor, Container, Description, FlexColumn, HEADER_NAVIGATION_MICROSITE_MENU_HEIGHT, MenuInnerWrap, MenuWrap, StyledImg, SubNavItem, SubNavItemsWrapper, SvgImage, TRANSITION_DURATION_MS, Title, Wrap };
//# sourceMappingURL=SubNavigation.styles.mjs.map
